import titleHubFilters from '@/constants/titleHubFilters';

export default {
  namespaced: true,
  state: {
    shipmentQueueTitles: [],
    preSaleShipmentQueueTitles: [],
    selectedFilter: titleHubFilters.All,
    labelsAvailable: true,
    numLabelsAvailableByDealer: {},
    counts: {
      shipToAcv: 0,
      shipped: 0,
      received: 0,
      all: 0,
    },
  },
  mutations: {
    addTitleToShipmentQueue(state, title) {
      const index = state.shipmentQueueTitles.findIndex((t) => t.titleId === title.titleId);
      if (index > -1) {
        state.shipmentQueueTitles.splice(index, 1, title);
      } else {
        state.shipmentQueueTitles.push(title);
      }
    },
    removeTitleFromShipmentQueue(state, titleId) {
      const index = state.shipmentQueueTitles.findIndex((title) => title.titleId === titleId);
      if (index > -1) {
        state.shipmentQueueTitles.splice(index, 1);
      }
    },
    clearShipmentQueue(state) {
      state.shipmentQueueTitles = [];
    },
    addTitleToPreSaleShipmentQueue(state, title) {
      const index = state.preSaleShipmentQueueTitles.findIndex((t) => t.titleId === title.titleId);
      if (index > -1) {
        state.preSaleShipmentQueueTitles.splice(index, 1, title);
      } else {
        state.preSaleShipmentQueueTitles.push(title);
      }
    },
    removeTitleFromPreSaleShipmentQueue(state, titleId) {
      const index = state.preSaleShipmentQueueTitles
        .findIndex((title) => title.titleId === titleId);
      if (index > -1) {
        state.preSaleShipmentQueueTitles.splice(index, 1);
      }
    },
    clearPreSaleShipmentQueue(state) {
      state.preSaleShipmentQueueTitles = [];
    },
    setSelectedFilter(state, filter) {
      state.selectedFilter = filter;
    },
    setLabelsAvailable(state, labelsAvailable) {
      state.labelsAvailable = labelsAvailable;
    },
    setNumLabelsAvailableByDealer(state, numLabelsAvailableByDealer) {
      state.numLabelsAvailableByDealer = numLabelsAvailableByDealer;
    },
    setShipToAcvCount(state, count) {
      state.counts.shipToAcv = count;
    },
    setShippedCount(state, count) {
      state.counts.shipped = count;
    },
    setReceivedCount(state, count) {
      state.counts.received = count;
    },
    setAllCount(state, count) {
      state.counts.all = count;
    },
  },
  actions: {
    addTitleToShipmentQueue({ commit }, title) {
      commit('addTitleToShipmentQueue', title);
    },
    removeTitleFromShipmentQueue({ commit }, titleId) {
      commit('removeTitleFromShipmentQueue', titleId);
    },
    clearShipmentQueue({ commit }) {
      commit('clearShipmentQueue');
    },
    addTitleToPreSaleShipmentQueue({ commit }, title) {
      commit('addTitleToPreSaleShipmentQueue', title);
    },
    removeTitleFromPreSaleShipmentQueue({ commit }, titleId) {
      commit('removeTitleFromPreSaleShipmentQueue', titleId);
    },
    clearPreSaleShipmentQueue({ commit }) {
      commit('clearPreSaleShipmentQueue');
    },
    setSelectedFilter({ commit }, filter) {
      commit('setSelectedFilter', filter);
    },
    setLabelsAvailable({ commit }, labelsAvailable) {
      commit('setLabelsAvailable', labelsAvailable);
    },
    setNumLabelsAvailableByDealer({ commit }, numLabelsAvailableByDealer) {
      commit('setNumLabelsAvailableByDealer', numLabelsAvailableByDealer);
    },
    setShipToAcvCount({ commit }, count) {
      commit('setShipToAcvCount', count);
    },
    setShippedCount({ commit }, count) {
      commit('setShippedCount', count);
    },
    setReceivedCount({ commit }, count) {
      commit('setReceivedCount', count);
    },
    setAllCount({ commit }, count) {
      commit('setAllCount', count);
    },
  },
  getters: {
    getShipmentQueueTitles: (state) => state.shipmentQueueTitles,
    getPreSaleShipmentQueueTitles: (state) => state.preSaleShipmentQueueTitles,
    getSelectedFilter: (state) => state.selectedFilter,
    getLabelsAvailable: (state) => state.labelsAvailable,
    getNumLabelsAvailableByDealer: (state) => state.numLabelsAvailableByDealer,
    getShipToAcvCount: (state) => state.counts.shipToAcv,
    getShippedCount: (state) => state.counts.shipped,
    getReceivedCount: (state) => state.counts.received,
    getAllCount: (state) => state.counts.all,
  },
};
